const appMenu = [
  {
    section: 'nav.dashboard',
    items: [
      { to: '/dashboard', label: 'nav.overview', iconClass: 'ti ti-layout-dashboard' },
      { to: '/wiki', label: 'nav.wiki', iconClass: 'ti ti-book-2' },
    ]
  },
  {
    section: 'nav.personal',
    items: [
      { to: '/profiles', label: 'nav.profiles', iconClass: 'ti ti-users', requiresPermission: 'profile.view' },
      { to: '/calls', label: 'calls.title', iconClass: 'ti ti-phone', requiresPermission: 'calls.view', requiresModule: 'calls' },
      { to: '/documents', label: 'nav.documents', iconClass: 'ti ti-file-description', requiresPermission: 'document.view' },
      { to: '/accounts', label: 'nav.accounts', iconClass: 'ti ti-wallet', requiresPermission: 'account.view' },
      { to: '/transactions', label: 'nav.transactions', iconClass: 'ti ti-arrows-exchange', requiresPermission: 'transaction.view' },
      { to: '/internal-mail', label: 'nav.internalMail', iconClass: 'ti ti-mail', requiresPermission: 'message.view' },
      { to: '/support', label: 'nav.support', iconClass: 'ti ti-headset', requiresPermission: 'ticket.view' },
      { to: '/leads', label: 'nav.leads', iconClass: 'ti ti-address-book', requiresPermission: 'lead.view' },
    ],
  },
  {
    section: 'nav.partners',
    items: [
      { to: '/partners', label: 'nav.partners', iconClass: 'ti ti-affiliate', requiresPermission: 'partner.view', end: true },
      { to: '/partners/settings', label: 'nav.partnerSettings', iconClass: 'ti ti-settings', requiresPermission: 'settings.view' },
      { to: '/commissions', label: 'nav.commissions', iconClass: 'ti ti-currency-dollar', requiresPermission: 'commission.view' },
      { to: '/commission-plans', label: 'nav.commissionPlans', iconClass: 'ti ti-list-details', requiresPermission: 'commission.view' },
    ],
  },
  {
    section: 'nav.compliance',
    items: [
      {
        to: '/system/compliance/sar',
        label: 'nav.sarQueue',
        iconClass: 'ti ti-file-alert',
        requiresComplianceMode: 'financial_regulation',
        requiresPermission: 'compliance.view',
      },
      {
        to: '/system/compliance/complaints',
        label: 'nav.complaints',
        iconClass: 'ti ti-message-report',
        requiresComplianceMode: 'financial_regulation',
        requiresPermission: 'compliance.view',
      },
      {
        to: '/system/compliance/breach',
        label: 'nav.breachLog',
        iconClass: 'ti ti-alert-triangle',
        requiresComplianceMode: 'financial_regulation',
        requiresPermission: 'compliance.view',
      },
    ],
  },
  {
    section: 'nav.marketing',
    items: [
      {
        to: '/marketing/emails/campaigns',
        label: 'nav.emails',
        iconClass: 'ti ti-mail',
        requiresAnyPermission: ['marketing_email.view', 'marketing_email.provider_manage'],
      },
    ],
  },
  {
    section: 'nav.admin',
    items: [
      {
        key: 'system',
        label: 'nav.system',
        iconClass: 'ti ti-adjustments-horizontal',
        children: [
          { to: '/system/user-settings', label: 'nav.userSettings', iconClass: 'ti ti-user-cog', requiresPermission: 'settings.view' },
          { to: '/system/settings/general', label: 'nav.systemSettings', iconClass: 'ti ti-settings-cog', requiresPermission: 'settings.view' },
          {
            to: '/system/legal',
            label: 'nav.legal',
            iconClass: 'ti ti-file-certificate',
            requiresAnyPermission: ['document.view', 'settings.manage'],
          },
          {
            to: '/system/security',
            label: 'nav.security',
            iconClass: 'ti ti-shield-lock',
            requiresAnyPermission: ['system.events.view', 'security_alert.view', 'audit_log.view', 'system.manage'],
          },
          { to: '/system/users', label: 'nav.users', iconClass: 'ti ti-user-shield', requiresPermission: 'user.view' },
          { to: '/system/telephony', label: 'telephony.title', iconClass: 'ti ti-phone', requiresPermission: 'calls.settings', requiresModule: 'calls' },
          { to: '/system/save-restore', label: 'nav.backupRestore', iconClass: 'ti ti-database-export', requiresPermission: 'backup.view' },
        ],
      },
      {
        key: 'payment-settings',
        label: 'nav.paymentSettings',
        iconClass: 'ti ti-credit-card',
        children: [
          { to: '/payment-settings/providers', label: 'nav.paymentProviders', requiresPermission: 'settings.view' },
          { to: '/payment-settings/currency-rates', label: 'nav.currencyRates', requiresPermission: 'settings.view' },
        ],
      },
    ],
  },
];

export default appMenu;
